import React from 'react';
import classnames from 'classnames';
import CSSTransition from 'react-transition-group/CSSTransition';

import { eventOn, eventOff } from '../../helpers/global';

import '../../sass/components/common/ConfirmationPopup.scss';

class ConfirmationPopup extends React.Component {
  constructor(props) {
    super();
    this.state = {
      hidden: !props.show,
      show: false,
      title: null,
      body: null,
      confirmText: null,
      cancelText: null,
      callback: null,
    };
  }

  componentDidMount = () => {
    if (this.props.global) {
      eventOn('showConfirmation', this.showConfirmation);
    }
  }

  componentWillUnmount = () => {
    if (this.props.global) {
      eventOff('showConfirmation', this.showConfirmation);
    }
  }

  showConfirmation = (e) => {
    const { title, body, confirmText, cancelText, callback } = e.detail[0];
    this.setState({
      hidden: false,
      show: true,
      title,
      body,
      confirmText,
      cancelText,
      callback,
    });
  }

  onOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      this.onCancel();
    }
  }

  onCancel = () => {
    if (this.props.global) {
      if (this.state.callback) {
        this.state.callback(false);
      }
      this.setState({show: false});
    } else {
      this.props.callback(false);
    }
  }

  onConfirm = () => {
    if (this.props.global) {
      if (this.state.callback) {
        this.state.callback(true);
      }
      this.setState({show: false});
    } else {
      this.props.callback(true);
    }
  }

  render = () => {
    const { show, title, body, confirmText, cancelText } = this.props.global ? this.state : this.props;
    return (
      <div
        className={classnames({
          'confirmationPopup': true,
          'hidden': this.state.hidden,
        })}
      >
        <CSSTransition
          in={show}
          timeout={350}
          classNames='fade'
          onEnter={() => this.setState({hidden: false})}
          onExited={() => this.setState({hidden: true})}
        >
          <div
            onClick={this.onOverlayClick}
            className='overlay'
          >
            <div className='popupWindow'>
              <div className='confirmTitle'>{title}</div>
              {body ?
                <div className='confirmBody' dangerouslySetInnerHTML={{__html: body}}/>
              : null}
              <div className='popupControls'>
                <div
                  onClick={this.onConfirm}
                  className='popupControl confirm'
                >{confirmText || 'Confirm'}</div>
                <div
                  onClick={this.onCancel}
                  className='popupControl cancel'
                >{cancelText || 'Cancel'}</div>
              </div>
            </div>
          </div>
        </CSSTransition>
      </div>
    )
  }
}

export default ConfirmationPopup;
